<template>
	<router-link :to="to" active-class="active" class="nav-button flex-align-center display-flex flex-row pl-5 flex-justify-space-between">
		<Row class="flex-align-center">
			<SIcon class="item-icon" v-if="localIcon" :name="localIcon" />
			<v-icon v-else class="item-icon">{{ icon }}</v-icon>
			<MaybeUpgradeRequiredIndicator v-if="billingFeatureId" :billingFeatureId="billingFeatureId">
				<template #default="{ indicator, isUpgradeRequired }">
					<Row>
						<h4 class="reg title-te ml-2">{{ name }}</h4>
						<component v-if="isUpgradeRequired" class="ml-2" :is="indicator" :billingFeatureId="billingFeatureId" iconOnly />
					</Row>
				</template>
			</MaybeUpgradeRequiredIndicator>
			<h4 v-else class="reg title-te ml-2">{{ name }}</h4>
		</Row>
		<Row class="flex-align-center">
			<component
				:id="itemId"
				:class="additionalItemSuffix.class"
				:is="additionalItemSuffix.component"
				v-if="additionalItemSuffix.component"
			/>
			<component :id="itemId" class="suffix" :is="settings.component" v-if="settings.component && hasPermissionToEditSettings" />
		</Row>
	</router-link>
</template>

<script>
import { mapGetters } from 'vuex';

import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { useInbox } from '@/store/modules/inboxes/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';

export default {
	name: 'NavigationAccordionButton',
	components: { MaybeUpgradeRequiredIndicator },
	props: {
		to: { type: Object },
		icon: { type: String },
		name: { type: String },
		settings: { type: Object },
		localIcon: { type: String },
		itemId: { type: [String, Number] },
		billingFeatureId: { type: String, default: null },
		additionalItemSuffix: { type: Object, default: () => ({}) },
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ useInbox }),
		hasPermissionToEditSettings() {
			return this.settings.hasPermissionToEditSettingsFunc({ inbox: this.useInbox(this.itemId), userId: this.user.id });
		},
	},
};
</script>

<style lang="scss" scoped>
.title-te {
	font-weight: 400;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
}
.nav-button {
	height: 28px;
	transition: 0.1s;
	border-radius: 7px;
	text-decoration: none;
	background: var(--white);
	&:hover {
		background: rgba(128, 128, 128, 0.1) !important;
		.suffix {
			display: flex;
		}
	}
	&.active {
		background: #e7e8f9;
		.title-te {
			color: #1b1c21;
		}
		.item-icon {
			::v-deep {
				svg,
				path,
				rect,
				line {
					stroke: black;
				}
			}
			color: #7368d1;
			font-weight: bold;
		}
	}
}
.suffix {
	display: none;
}
.item-icon {
	width: 12px;
	font-size: 14px;
	margin-top: 2px;
}
</style>
